import React, { useState, useEffect } from "react";
import styles from "./SectionIcon.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { IconSuggest } from "../../common/DynamicTables/DbIcon/IconSuggest";

type Props = {
  section: {
    id: number;
    name: string;
    iconId: number;
    isFirstCreate: boolean;
    isMySection: boolean;
    icon_path: IconType;
  };
  clientCode: string;
  isEditPermission: boolean;
};

type IconType = { unicode: string | null; image_path: string | null };

type IconData = {
  icon_id: number;
  image_path?: string;
  unicode?: string | null;
};

export const SectionIcon = ({ section, clientCode, isEditPermission }: Props) => {
  const [isIconOpen, setIsIconOpen] = useState<boolean>(false);
  const [currentIcon, setCurrentIcon] = useState<IconType>(section.icon_path);
  const [isFirstCreate, setIsFirstCreate] = useState<boolean>(section.isFirstCreate);

  const getRandomIcon = (iconDataObj: Record<string, IconData[]>): IconData | null => {
    const allIcons = Object.values(iconDataObj).flat();
    if (allIcons.length === 0) return null;

    const randomIndex = Math.floor(Math.random() * allIcons.length);
    return allIcons[randomIndex];
  };

  const setRandomIcon = (iconDataObj: Record<string, IconData[]>) => {
    const icon = getRandomIcon(iconDataObj);
    if (icon) {
      setCurrentIcon({ unicode: icon.unicode ?? null, image_path: icon.image_path ?? null });
      registerIcon(icon.icon_id);
      setIsFirstCreate(false);
    }
  };

  const fetchIcons = async () => {
    await axios.get(`/${clientCode}/icons`).then((res) => {
      setRandomIcon(res.data.icons);
    });
  };

  const registerIcon = async (iconId: number) => {
    await axios.patch(`/${clientCode}/icons/sections/${section.id}`, {
      icon_id: iconId,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (isFirstCreate) {
        await fetchIcons();
      }
    };
    fetchData();
  }, [section.id, clientCode]);

  return (
    <>
      <div
        id="iconImg"
        onClick={() => isEditPermission && !section.isMySection && setIsIconOpen(!isIconOpen)}
        className={styles.sectionIcon}
        style={{ cursor: isEditPermission && !section.isMySection ? "pointer" : "default" }}
      >
        {currentIcon?.unicode ? (
          <span className={styles.iconImg} id="iconImg">
            {currentIcon?.unicode}
          </span>
        ) : currentIcon?.image_path ? (
          <img src={currentIcon?.image_path} id="iconImg" width={48} height={48} />
        ) : !isFirstCreate ? (
          <div id="iconImg" className={styles.normalIcon}>
            {section.isMySection ? (
              <img src={getImageUrl("images/icons/my.png")} id="iconImg" width={28} />
            ) : (
              <div id="iconImg">{section.name.charAt(0)}</div>
            )}
          </div>
        ) : null}
      </div>
      {isIconOpen && (
        <IconSuggest
          client={clientCode}
          pageId={section.id}
          pageType="sections"
          setCurrentIcon={setCurrentIcon}
          isIconOpen={isIconOpen}
          setIsIconOpen={setIsIconOpen}
          defaultImagePath=""
        />
      )}
    </>
  );
};
